export const editorConfig = {
  features: {
    markdown: true,
    headings: true,
    bold: {
      enabled: true,
      showToolbar: true,
    },
    italic: {
      enabled: true,
      showToolbar: true,
    },
    bulletList: true,
    orderedList: true,
    taskList: true,
    blockquote: true,
    code: true,
    image: true,
    iframe: true,
    video: true,
    dropCursor: true,
    hardBreak: true,
    nodeFormatting: true,
    strike: true,
    subscript: true,
    superscript: true,
    fontSize: true,
    textColor: true,
    trailingNode: true,
    underline: { enabled: true, showToolbar: true },
    history: true,
    horizontalRule: true,
    mention: true,
    table: true,
    link: { enabled: true, showToolbar: true },
    placeholder: true,
    codeblock: true,
    find: true,
    tableNavigation: true,
    undoRedo: true,
    textSize: true,
    textDecoration: true,
    textAlign: true,
    links: true,
    mediaUpload: true,
    tableInsert: true,
    findExtension: true,
    tableNavigationExtension: true,
    dateNodeExtension: true,
    emojiEnabled: true,
    actionItem: true,
    ai: {
      translation: { enabled: true, showToolbar: true },
      improveWriting: { enabled: true, showToolbar: true },
      fixGrammer: { enabled: true, showToolbar: true },
    },
    calloutPanel: true,
    inlineComment: true,
    accordion: true,
    textHighlight: true,
  },
};

const resolveObjectKeyLabel = (label) => {
  if (typeof label !== 'string') return null;
  const labels = label.split('-')?.map((it, i) => {
    if (i !== 0) return String(it).charAt(0).toUpperCase() + String(it).slice(1);
    return it;
  });
  return labels.join('');
};

const getToolbarActions = (prefix = '', config) => {
  if (!prefix) prefix = '';
  const output = [];
  Object.entries(config).forEach(([key, value]) => {
    const actionKey = resolveObjectKeyLabel(`${prefix}-${key}`);
    if (typeof value === 'object' && value?.enabled && value?.showToolbar) {
      output.push(actionKey);
    } else if (typeof value === 'object') {
      output = output.concat(getToolbarActions(actionKey, value));
    }
  });
  return output;
};

export const shortcutKeyList = [
  {
    key: 'action-item',
    label: 'Action item',
    description: 'Create and assign action items.',
    keywords: ['action', 'item', 'items', 'actionitem', 'actionitems', 'list'],
    isEnabled: editorConfig.features['actionItem'],
  },
  {
    key: 'emoji',
    label: 'Emoji',
    description: 'Use emoji to express ideas 🎉 and emotions 😀.',
    keywords: ['emoji', 'e'],
    isEnabled: editorConfig.features['emojiEnabled'],
  },
  {
    key: 'table',
    label: 'Table',
    description: 'Insert a table.',
    keywords: ['data', 'table', 't'],
    isEnabled: editorConfig.features['table'],
  },
  {
    key: 'code-snippet',
    label: 'Code snippet',
    description: 'Display code and syntax highlighting.',
    keywords: ['codeblock', 'code', 'snippet', 'codesnippet'],
    isEnabled: editorConfig.features['code'],
  },
  {
    key: 'bullet-list',
    label: 'Bullet list',
    description: 'Create an unordered list.',
    keywords: ['list', 'bullet', 'bulletlist', 'item', 'items'],
    isEnabled: editorConfig.features['bulletList'],
  },
  {
    key: 'numbered-list',
    label: 'Numbered list',
    description: 'Create an ordered list.',
    keywords: ['list', 'number', 'numberlist', 'item', 'items'],
    isEnabled: editorConfig.features['orderedList'],
  },
  {
    key: 'quote',
    label: 'Quote',
    description: 'Insert a quote or citation.',
    keywords: ['quote', 'blockquote', 'callout'],
    isEnabled: editorConfig.features['taskList'],
  },
  {
    key: 'heading-1',
    label: 'Heading 1',
    description: 'Use this for top level headings.',
    keywords: ['heading', 'heading1', 'h1', 'h'],
    isEnabled: editorConfig.features['headings'],
  },
  {
    key: 'heading-2',
    label: 'Heading 2',
    description: 'Use this for key sections.',
    keywords: ['heading', 'heading2', 'h2', 'h'],
    isEnabled: editorConfig.features['headings'],
  },
  {
    key: 'heading-3',
    label: 'Heading 3',
    description: 'Use this for sub sections and group headings.',
    keywords: ['heading', 'heading3', 'h3', 'h'],
    isEnabled: editorConfig.features['headings'],
  },
  {
    key: 'heading-4',
    label: 'Heading 4',
    description: 'Use this for deep headings.',
    keywords: ['heading', 'heading4', 'h4', 'h'],
    isEnabled: editorConfig.features['headings'],
  },
  {
    key: 'heading-5',
    label: 'Heading 5',
    description: 'Use this for grouping list items.',
    keywords: ['heading', 'heading5', 'h5', 'h'],
    isEnabled: editorConfig.features['headings'],
  },
  {
    key: 'heading-6',
    label: 'Heading 6',
    description: 'Use this for low level headings.',
    keywords: ['heading', 'heading6', 'h6', 'h'],
    isEnabled: editorConfig.features['headings'],
  },
  {
    key: 'date',
    label: 'Date',
    description: 'Add date',
    keywords: ['date', 'dat', 'da', 'd'],
    isEnabled: editorConfig.features['dateNodeExtension'],
  },
];
